import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 94%;
  overflow-x: auto;
  height: 100%;
`;

export const FloatShadow = styled.div`
  box-shadow: ${(props) => (props.showBoxShadow ? 'inset -13px 0px 4px -4px rgba(0, 0, 0, 0.2);' : '')};
  position: sticky;
  top: 7pt;
  right: -1px;
  min-width: 13px;
  height: 248px;
`;
